export default function CheckmarkIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8.28174 17.4111C7.8833 17.4111 7.54297 17.234 7.26074 16.8799L2.96094 11.501C2.85579 11.3737 2.77832 11.2492 2.72852 11.1274C2.68424 11.0057 2.66211 10.8812 2.66211 10.7539C2.66211 10.4661 2.75618 10.2282 2.94434 10.04C3.13802 9.85189 3.38151 9.75781 3.6748 9.75781C4.01237 9.75781 4.29736 9.90999 4.52979 10.2144L8.24854 14.9873L15.4536 3.54053C15.5809 3.34684 15.7109 3.21126 15.8438 3.13379C15.9766 3.05078 16.1481 3.00928 16.3584 3.00928C16.6462 3.00928 16.8813 3.10059 17.064 3.2832C17.2466 3.46029 17.3379 3.69271 17.3379 3.98047C17.3379 4.09668 17.3185 4.21566 17.2798 4.3374C17.241 4.45361 17.1802 4.57812 17.0972 4.71094L9.29443 16.8716C9.05094 17.2313 8.71338 17.4111 8.28174 17.4111Z" />
    </svg>
  );
}
